import React from "react";

import TimelineContainer from "./Timeline.container";
const SubjectTimelineComponent = (props: any) => {
    const { subject } = props;
    return (
        <main className="bg-gray-50 min-h-screen ">
            <div className="container mx-auto">
                <div className="flex items-center mb-4">
                    <button
                        onClick={() => window.history.back()}
                        className="mr-2 p-2 rounded-full hover:bg-gray-200"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <div className="text-2xl font-bold">{subject}</div>
                </div>
                <TimelineContainer
                    subject={subject}
                />
            </div>
        </main>
    );
};

export default SubjectTimelineComponent;